import { SearchFieldWidget, TabStyles } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../codegen/Localize';

const testId = 'definition-subspace-values-toolbar';

export interface DefinitionSubspaceValuesControlsProps {
  searchText: string;
  onChangeSearch: (searchText: string) => void;
}

export const DefinitionSubspaceValuesControls = (props: DefinitionSubspaceValuesControlsProps) => {
  return <SearchFieldWidget
    handleChange={props.onChangeSearch}
    handleCancelSearch={() => props.onChangeSearch('')}
    text={props.searchText}
    testId={testId}
    placeholder={Messages.dataRoleDefinitionSubspace_Values_SearchValues()}
    containerStyle={{marginRight: TabStyles.Spacing.MediumSpace}}/>;
};
